.inline-form-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
}

/* These styles are specific to a 15px textfield */
.inline-form-wrapper > input {
    box-shadow: 0 2px 8px rgba(27, 160, 224, 0.3);
    padding-left: 15px;
    font-size: 15px;
    padding-top: 4px;
}

.form-controls {
    position: absolute;
    bottom: -24px;
    right: 0;
    margin-top: 8px;
}

.form-controls > * {
    margin-left: 8px;
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
}
